<template>
  <div class="news-frame">
    <Content :routeArr="routeArr" />

    <div class="box">
      <!-- 列表展示 -->
      <div class="ul-box" v-show="!detailIf">
        <div class="m-title" v-if="isMobile == 1">{{ $store.state.name }}</div>
        <div class="ul">
          <el-card
            class="box-card"
            shadow="hover"
            v-for="item in newsList"
            :key="item.id"
          >
            <div class="card-body" @click="getInfo(item.id)">
              <div class="left">
                <img :src="URL + item.newsImageUrl" alt="" />
              </div>
              <div class="right">
                <div class="right-top">
                  <div class="right-title">
                    {{ item.title }}
                  </div>
                  <div class="time">
                    {{
                      item.publishTime
                        ? item.publishTime.split(" ")[0]
                        : item.createTime.split(" ")[0]
                    }}
                  </div>
                </div>
                <div class="right-desc">
                  {{ item.description }}
                </div>
                <button class="right-btn">查看更多</button>
              </div>
            </div>
          </el-card>
        </div>

        <el-pagination
          :hide-on-single-page="newsTotal < 11"
          @current-change="handleCurrentChange"
          :current-page="params.pageIndex"
          :page-size="params.pageSize"
          :layout="!isMobile ? layoutPc : layoutM"
          :total="newsTotal"
        >
        </el-pagination>
      </div>

      <!-- 详情展示 -->
      <div class="detail" v-show="detailIf">
        <div class="btn" @click="backto">
          <img src="../../assets/back.svg" alt="" /> 返回新闻列表
        </div>
        <div class="detail-title">{{ detail.title }}</div>
        <div class="detail-time">
          发布时间:{{
            detail.publishTime ? detail.publishTime : detail.createTime
          }}
        </div>
        <div class="detail-detail" v-html="detail.contentStr"></div>

        <div class="other">
          <div class="pre" @click="preOne">
            <span class="symbol">&larr;</span> 上一篇
            <span class="preview"
              >:{{ preNew.id ? preNew.title : "已经是第一篇了" }}</span
            >
          </div>
          <div class="next" @click="nextOne">
            下一篇 <span class="symbol">&rarr;</span>
            <span class="preview"
              >:{{ nextNew.id ? nextNew.title : "已经是最后一篇了" }}</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Content from "@/components/content.vue";

import { sysNewsList, getRecentNews } from "../../util/news/news.js";
import { URL } from "../../util/config";
export default {
  data() {
    return {
      URL,
      activeCode: "",
      params: {
        pageIndex: 1,
        pageSize: 10,
        newsCode: "",
        typeCode: "",
      },
      getNewIng: false,
      newsList: [],
      newsTotal: 0,
      moduleTitle: "",
      moduleDesc: "", // 模版渲染的标题以及英文翻译
      tabName: "",
      moduleFlag: 1,
      clickConfig: 0,
      detail: {},
      preNew: {},
      nextNew: {},
      detailIf: false, // 判断是否在查看新闻详情
      routeArr: [],
      isMobile: sessionStorage.getItem("isMobile"),
      layoutPc: "total, sizes, prev, pager, next, jumper",
      layoutM: "total,prev,pager,next",
    };
  },
  components: {
    Content,
  },
  created() {},
  mounted() {
    this.params.newsCode = this.$store.state.code;
    this.routeArr = [
      { name: "首页", path: "/" },
      { name: this.$store.state.name, path: "/news" },
    ];
    this.getList();
  },
  methods: {
    getList() {
      //获取列表
      sysNewsList(this.params).then((res) => {
        if (res.code === 0) {
          this.newsTotal = res.data.total;
          this.newsList = res.data.list;
        }
      });
    },
    getRecent() {
      // 获取最近新闻 api
      getRecentNews({ ...this.params, newsId: this.detail.id }).then((res) => {
        this.getNewIng = false;
        this.preNew = res.data.last == null ? {} : res.data.last;
        this.nextNew = res.data.next == null ? {} : res.data.next;
      });
    },
    // 展示新闻详情
    getInfo(id) {
      this.$router.push(
        "/newDetail?id=" + id + "&num=" + this.params.pageIndex
      );
    },
    backto() {
      this.detailIf = false;
      this.detail = {};
      this.nextNew = {};
      this.preNew = {};
      this.getList();
    },
    // 上一篇
    preOne() {
      if (this.preNew.id) {
        if (!this.getNewIng) {
          this.getNewIng = true;

          this.params.pageIndex = this.preNew.pageIndex;
          this.detail = { ...this.preNew };
          this.getRecent();
          window.scrollTo(0, 0);
        }
      }
    },
    // 下一篇
    nextOne() {
      if (this.nextNew.id) {
        if (!this.getNewIng) {
          this.getNewIng = true;

          this.params.pageIndex = this.nextNew.pageIndex;
          this.detail = { ...this.nextNew };
          this.getRecent();
          window.scrollTo(0, 0);
        }
      }
    },
    handleCurrentChange(val) {
      this.params.pageIndex = Number(val);
      this.getList();
    },
  },
};
</script>

<style lang="scss" scoped>
@function pxToRem($args) {
  @return $args / 50 + rem;
}

@keyframes scal {
  0% {
    transform: scale(1);
  }
  33% {
    transform: scale(0.9);
  }
  66% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
.news-frame {
  .box {
    width: 1200px;
    margin: 60px auto;

    .m-title {
      font-size: pxToRem(20);
      line-height: pxToRem(50);
      margin-bottom: pxToRem(20);
      font-weight: bold;
      color: #cc0f16;
      text-align: center;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: pxToRem(40);
        height: 1px;
        background-color: $theme;
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
      }
    }

    .card-body {
      display: flex;

      &:hover {
        cursor: pointer;

        .right-btn {
          animation: scal 0.5s;
        }
      }
    }

    .left {
      width: fit-content;
      flex-shrink: 0;

      img {
        width: 280px;
        height: 180px;
        display: block;
      }
    }
    .right {
      flex-grow: 1;
      padding-left: 20px;

      .right-top {
        font-size: 20px;
        color: #444444;
        position: relative;

        .right-title {
          font-weight: 600;
          width: 700px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .time {
          font-size: 14px;
          line-height: 30px;
          color: #999999;
          position: absolute;
          top: 0;
          right: 0;
        }
      }
      .right-desc {
        margin: 20px 0;
        font-size: 13px;
        line-height: 24px;
        letter-spacing: 1px;
        height: 66px;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        text-overflow: ellipsis;
        -webkit-line-clamp: 3; //例如超过2行显示省略号
      }
      .right-btn {
        width: 120px;
        height: 30px;
        background-color: #fff;
        border: 1px $theme solid;
        color: $theme;
        font-size: 14px;
        line-height: 30px;
        text-align: center;

        &:hover {
          cursor: pointer;
        }
      }
    }

    .el-pagination {
      text-align: center;
      margin-top: 40px;
    }
  }
}
@media (max-width: 1024px) {
  .news-frame .box {
    width: 100%;
    margin: 0 0 pxToRem(30);

    .left img {
      width: pxToRem(80);
      height: pxToRem(64);
    }
    .right {
      overflow: hidden;
      .right-top {
        .right-title {
          width: 65%;
          font-size: pxToRem(14);
        }
        .time {
          font-size: pxToRem(13);
          line-height: normal;
        }
      }
      .right-desc {
        height: pxToRem(50);
        margin: pxToRem(7) 0;
        -webkit-line-clamp: 2;
      }
      .right-btn {
        display: none;
      }
    }
  }
}
</style>
